import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteSupplier, getSuppliers } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const SupplierList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleSuppliers();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteSupplier(id, { archive: true });
            if (data.success) handleSuppliers();
        } catch (err) { }
    };

    const handleSuppliers = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getSuppliers(params);
            const { resultsPerPage, totalCount, suppliers, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(suppliers.map(supplier => {
                return {
                    company: supplier?.company?.name || '-',
                    nameLocal: supplier?.nameLocal || '-',
                    createdAt: supplier?.createdAt,
                    email: supplier?.email || '',
                    phone: supplier?.phone || '',
                    image: supplier.image || '',
                    name: supplier.name || '',
                    _id: supplier._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleSuppliers(page);
    };

    const AddSupplier = () => navigate('/supplier/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_supplier',
                        title: 'supplier_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleSuppliers,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_supplier',
                                action: AddSupplier,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader
                            filter={{ isFilter: true, from: 'supplier' }}
                            applyFilter={handleSuppliers}
                        />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={6}
                                type="supplier"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SupplierList;